import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { SearchItem } from '../../entities';
import { FleetCondition, InspectionsPerformed, RepairsCost, InspectionDue, ComponentsFleetConditionEvalsViewModel } from './widgets.model';
import { catchError } from 'rxjs/operators';

@Injectable()
export class WidgetsService {
  private readonly API_DASHBOARD = 'api/dashboard/'
    private readonly GET_FLEET_CONDITION = this.API_DASHBOARD + 'GetActionsRequired';
    private readonly GET_INSPECTIONS_PERFORMED = this.API_DASHBOARD + 'GetInspectionsPerformed';
    private readonly GET_TOTAL_COST_REPAIRS = this.API_DASHBOARD + 'GetTotalCostOfRepairs';
  private readonly GET_INSPECTION_DUE_BY_TODAY = this.API_DASHBOARD + 'GetInspectionsDueByToday';
  private readonly GET_FLEETCONDITION_OVERVIEW  = this.API_DASHBOARD + 'GetFleetConditionOverViewOnBasedOnCompart';

  constructor(private _http: HttpClient) { }

  public getFleetCondition(searchItems: SearchItem[]): Observable<FleetCondition> {
    return this._http.post<FleetCondition>(this.GET_FLEET_CONDITION, searchItems).pipe(catchError(this.handleError));
  }

  public getInspectionsPerformed(searchItems: SearchItem[]): Observable<InspectionsPerformed[]> {
    return this._http.post<InspectionsPerformed[]>(this.GET_INSPECTIONS_PERFORMED, searchItems).pipe(catchError(this.handleError));
  }

  public getTotalCostOfRepairs(searchItems: SearchItem[]): Observable<RepairsCost[]> {
    return this._http.post<RepairsCost[]>(this.GET_TOTAL_COST_REPAIRS, searchItems).pipe(catchError(this.handleError));
  }

  public getInspectionDueByToday(searchItems: SearchItem[]): Observable<InspectionDue[]> {
    return this._http.post<InspectionDue[]>(this.GET_INSPECTION_DUE_BY_TODAY, searchItems).pipe(catchError(this.handleError));
  }


  public getFleetConditionOverviewOnCompart(searchItems: SearchItem[]):Observable<ComponentsFleetConditionEvalsViewModel[]>{
    return this._http.post<ComponentsFleetConditionEvalsViewModel[]>(this.GET_FLEETCONDITION_OVERVIEW, searchItems).pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
}
